/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import InputField from "../../../shared-ui/input-field";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import RadioButtonComponent from "../../../shared-ui/radio-button";
import SingleChoiceComponent from "./answers-types/single-selection";
import MultipleChoiceComponent from "./answers-types/mutiple-selection";
// import "react-accessible-accordion/dist/fancy-example.css";
import _, { initial, isArray, isEmpty } from "lodash";
// import { longSurveyQuestions } from "./long-survey-master-json";
// import { shortSurveyQuestions } from "./short-survey-master-json";
import NumericValueComponent from "./answers-types/numeric";
import SearchSelectComponent from "./answers-types/search-selection";
import Button from "../../../shared-ui/button";
import LongSuveryRankingComponent from "./answers-types/long-survey-ranking";
import ShortSuveryRankingComponent from "./answers-types/short-survey-ranking";
import { isTemplateTail } from "typescript";
import { response } from "../../../results-landing/mock-response";
import { handleMetaRecoResultAPI } from "../../../../services/adminToolServices/getMetaRecommendation";
import { threadId } from "worker_threads";
import { handleNestedSort } from "../../../../utils/getSort";
import AdminPopupComponent from "../../../shared-ui/popup/admin-popup";
import MessageStrip from "../../../shared-ui/message-strip";
import { handleCheckTestDiffStateAPI } from "../../../../services/adminToolServices/checkStateDifference";

interface InputSectionProps {
  handleViewRules: (isRulesVisiable: boolean) => void;
  isRulesVisiable: boolean;
  callBack?: (response: any, inputs?: any) => void;
  callBackDifference?: (status: boolean, statusIsSet: boolean) => void;
  handleEditMode?: (response: any) => void;
  isViewMode: boolean;
  isEditMode: boolean;
  handleRunLoad: (value: any) => void;
  testCaseName: string;
}

interface InputSectionState {
  jsonWithAnswers: any;
  isPathSelected: boolean;
  fileContent: any;
  initialJsonWithAnswers: any;
  answerObj: any;
  isFileDragged: boolean;
  surveyName: string;
  isMenuOpen: boolean;
  accordionItemsState: string;
  valueToSearch: string;
  storeUserResponse: any;
  selectedPath: any;
  openList: Boolean;
  invalidAnswers: any;
  buttonLabel: string;
  longSurveyQuestions: any;
  shortSurveyQuestions: any;
  isSearch: boolean;
  isLeavePopUpOpen: boolean;
  fileData: any;
  isImportedJsonInvalid: boolean;
  isApiFailed: boolean;
  ApiFailedMessage: string;
  isExpandAll: any;
}

class InputSection extends React.Component<any, InputSectionState> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      jsonWithAnswers: [],
      isPathSelected: false,
      fileContent: [],
      initialJsonWithAnswers: [],
      answerObj: [],
      isFileDragged: false,
      surveyName: "",
      isMenuOpen: false,
      accordionItemsState: "collapsed",
      valueToSearch: "",
      storeUserResponse: [],
      selectedPath: undefined,
      openList: false,
      invalidAnswers: [],
      buttonLabel: "Run",
      longSurveyQuestions: [],
      shortSurveyQuestions: [],
      isSearch: false,
      isLeavePopUpOpen: false,
      fileData: {},
      isImportedJsonInvalid: false,
      isApiFailed: false,
      ApiFailedMessage: "",
      isExpandAll: false,
    };
  }

  componentDidMount = () => {
    const masterJsonData = localStorage.getObj("masterJson");
    if (masterJsonData !== undefined && !_.isEmpty(masterJsonData)) {
      this.setState(
        {
          longSurveyQuestions: masterJsonData?.fullSurvey,
          shortSurveyQuestions: masterJsonData?.shortSurvey,
        },
        () => {
          let metaData: any = JSON.parse(
            localStorage.getItem("meta_result") || "[]"
          );
          let answersData: any = JSON.parse(
            localStorage.getItem("answersObj") || "{}"
          );

          if (
            answersData !== "{}" &&
            (answersData !== undefined || answersData !== null)
          ) {
            this.setState(
              {
                fileContent: answersData,
              },
              () => {
                this.handlePathSelection(answersData);
                // if (this.props.callBack) {
                //   this.props.callBack(metaData, inputs);
                // }
              }
            );
          }
          if (
            metaData !== "[]" &&
            metaData?.data?.getMetaRecommendationById?.inputs !== undefined
          ) {
            let inputs = JSON.parse(
              metaData?.data?.getMetaRecommendationById?.inputs
            );
            this.setState(
              {
                fileContent: inputs,
              },
              () => {
                this.handlePathSelection(inputs);
                if (this.props.callBack) {
                  this.props.callBack(metaData, inputs);
                }
              }
            );
          }
        }
      );
    }
  };

  componentDidUpdate(prevProps: any, prevState: InputSectionState) {
    if (this.state.isMenuOpen) {
      const concernedElement: Element | null = document.querySelector(
        ".section-options-wrapper"
      );
      // attach/remove event handler
      document.addEventListener("click", (event: any) => {
        if (concernedElement && !concernedElement.contains(event.target)) {
          this.setState({
            isMenuOpen: false,
          });
        }
      });
    }

    const enteredEditWhileViewing = 
      !prevProps.isEditMode && this.props.isEditMode && this.props.isViewMode;

    if (enteredEditWhileViewing) {
      if (this.state.buttonLabel !== "Run") {
        this.handleRun("Edit");
      }
    }
  };

  omitDeep = (data: any) => {
    let self = this;
    _.forEach(data, function (value, key) {
      if (_.isObject(value)) {
        self.omitDeep(value);
      } else if (key === "__typename") {
        delete data[key];
      }
    });
    return data;
  };

  createRecoData = async (userData: any) => {
    let recoData: any = {};
    let recoInputData: any = {};
    recoInputData.length > 0
      ? (recoInputData.length = 0)
      : _.map(userData, function (respData: any) {
          // reco ID array storage
          if (Array.isArray(respData.recoId)) {
            _.map(respData.recoId, (recoIds, index) => {
              const key: any = recoIds;
              recoData[key] = isNaN(respData.recoValues[index])
                ? respData.recoValues[index]
                : _.isNull(respData.recoValues[index]) ||
                  respData.recoValues[index] === true
                ? respData.recoValues[index]
                : Number(respData.recoValues[index]);
            });
          } else if (respData?.recoId?.toLowerCase() === "needstaterank") {
            // reco ID ranking storage
            let rankObj: any = {};

            _.map(respData.recoValues, (rankData, index) => {
              let keySuffix = index + 1;
              const key: any = "r" + keySuffix;
              rankObj[key] = isNaN(rankData)
                ? rankData
                : _.isNull(rankData) || rankData === true
                ? rankData
                : Number(rankData);
            });
            recoData["NeedstateRank"] = rankObj;
          } else {
            const key: any = respData.recoId;
            recoData[key] = isNaN(respData.recoValues)
              ? respData.recoValues
              : _.isNull(respData.recoValues) || respData.recoValues === true
              ? respData.recoValues
              : Number(respData.recoValues);
          }
        });
    // recoInputData = JSON.stringify(recoData);
    // return await handleMetaRecoResultAPI(recoInputData);
    recoInputData = JSON.stringify(recoData);
    localStorage.setItem("answersObj", recoInputData);
    const data = handleMetaRecoResultAPI(recoInputData, this.props);
    data.then((response: any) => {
      if (response?.error === true) {
        this.setState(
          {
            isApiFailed: true,
            ApiFailedMessage: response?.message,
          },
          () => {
            this.props.handleRunLoad(false);
            setTimeout(() => {
              this.setState({
                isApiFailed: false,
                ApiFailedMessage: "",
              });
            }, 3000);
          }
        );
      } else {
        if (this.props.callBack) {
          const { testCaseName, isEditMode } = this.props;
          if (isEditMode) {
            this.props.callBackDifference(null, null);
            let recoOutput: any =
              response?.data?.getMetaRecommendation?.recommendations;

            const updatedOutput: any = this.omitDeep(recoOutput);
            let testInputObj: any = {};
            testInputObj.test_id = testCaseName;
            testInputObj.current_output = JSON.stringify(updatedOutput);
            const checkStateDifferenceData: any = handleCheckTestDiffStateAPI(
              testInputObj,
              this.props
            );
            checkStateDifferenceData.then((resp: any) => {
              if (resp.error === true) {
                this.props.callBackDifference(null, null);
              } else {
                this.props.callBackDifference(resp.status, true);
              }
            });
          }
          this.setState({ buttonLabel: "Edit" });
          this.props.callBack(response, recoData);
        }
      }
    });
    this.setState({
      storeUserResponse: [],
    });
  };

  handleInputChange = (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState: boolean,
    isDependent?: boolean,
    dependentQuestions?: any
  ) => {
    if (questionValue === "Path") {
      if (answer.id === "long-survey") {
        let data: any = _.cloneDeep(this.state.longSurveyQuestions);
        data.forEach((element: any) => {
          if (element.question_type === "ranking") {
            element.answer = [
              { id: "everyday-health", value: "Everyday Health" },
            ];
          }
        });

        this.setState({
          jsonWithAnswers: data,
          initialJsonWithAnswers: data,
          isPathSelected: true,
          selectedPath: {
            id: "long-survey",
            value: "Holistic Path",
            isChecked: true,
          },
          surveyName: "Holistic Path",
        });

        this.setState({});
      } else {
        let data: any = _.cloneDeep(this.state.shortSurveyQuestions);

        data.forEach((element: any) => {
          if (element.question_type === "short_survey_ranking") {
            // element.answer = [];
          }
        });

        this.setState({
          jsonWithAnswers: data,
          initialJsonWithAnswers: data,
          isPathSelected: true,
          selectedPath: {
            id: "short-survey",
            value: "Focused Path",
            isChecked: true,
          },
          surveyName: "Focused Path",
        });
        this.setState({});
      }
    } else {
      const { jsonWithAnswers, initialJsonWithAnswers } = this.state;
      let data: any = [...jsonWithAnswers];
      let initialData: any = [...initialJsonWithAnswers];

      let needStateAllQuestions = _.find(initialData, {
        question_value: "NeedstateRank",
      }).dependent;

      let needStateArray: any = _.map(needStateAllQuestions, "questions");
      let finalNeedStateQuestions: any = needStateArray.flat();
      let dependencyNeedStates: any = [];
      finalNeedStateQuestions.forEach((element: any) => {
        if (element.dependent.length > 0) {
          dependencyNeedStates.push(element.dependent[0].questions);
        }
      });
      let finalDependencyQuestions: any = dependencyNeedStates.flat();
      let combinedQuestions = [
        ...finalNeedStateQuestions,
        ...finalDependencyQuestions,
      ];
      const uniqueCombinedQuestions = _.uniqBy(
        [...combinedQuestions],
        "question_value"
      );

      if (isDependent && dependentQuestions && dependentQuestions.length > 0) {
        const objIndexQs = data.findIndex(
          (obj: any) => obj.question_title === questionTitle
        );
        const objIndexQsInitial = initialData.findIndex(
          (obj: any) => obj.question_title === questionTitle
        );
        for (let index = 0; index < dependentQuestions.length; index++) {
          const element = dependentQuestions[index];
          let arr: any = [];
          arr.push(element);
          let indexOfItem = _.findIndex(data, element);
          if (indexOfItem === -1) {
            data.splice(objIndexQs + 1 + index, 0, ...arr);
          }
          let filterRankingQs: any = uniqueCombinedQuestions.filter(
            (x) => x.id === element.id
          );
          if (filterRankingQs.length === 0) {
            let indexOfItemInitial = _.findIndex(initialData, element);
            if (indexOfItemInitial === -1) {
              initialData.splice(objIndexQsInitial + 1 + index, 0, ...arr);
            }
          }
        }
      } else {
        if (dependentQuestions && dependentQuestions.length > 0) {
          for (let index = 0; index < dependentQuestions.length; index++) {
            const element = dependentQuestions[index];
            let indexOfItem = _.findIndex(data, element);
            if (indexOfItem > -1) {
              data.splice(_.findIndex(data, element), 1);
            }
            let filterRankingQs: any = uniqueCombinedQuestions.filter(
              (x) => x.id === element.id
            );
            if (filterRankingQs.length === 0) {
              let indexOfItemInitial = _.findIndex(initialData, element);
              if (indexOfItemInitial > -1) {
                initialData.splice(_.findIndex(initialData, element), 1);
              }
            }
          }
        }
      }
      if (isNeedState) {
        const needStateData = _.find(initialData, {
          question_value: "NeedstateRank",
        }).dependent;
        const filteredData = needStateData.filter((element: any) =>
          answer.find((ans: any) => element.conditions[0] === ans.id)
        );
        const sortedData = answer.map((i: any) =>
          filteredData.find((j: any) => j.conditions[0] === i.id)
        );
        const compactSortedData = _.compact(sortedData);
        const result = _.map(compactSortedData, _.property("questions")).flat();
        const uniqueQuestions: any = _.uniqBy([...result], "question_value");
        for (let key in uniqueQuestions) {
          delete uniqueQuestions[key].answer;
        }
        let finalData: any = [];

        finalData = [...initialData];

        let objIndexNeedStateRef: number = 0;
        objIndexNeedStateRef = finalData.findIndex(
          (obj: any) => obj.question_value === questionValue
        );

        finalData.splice(objIndexNeedStateRef + 1, 0, ...uniqueQuestions);
        data = finalData;

        const objIndex = data.findIndex(
          (obj: any) => obj.question_value === "NeedstateRank"
        );
        data[objIndex].answer = answer;
      } else if (questionType === "dropdown") {
        data.forEach((item: any) => {
          if (item.question_title === questionTitle) {
            item.dropdown_combo.forEach((element: any) => {
              if (element.question_value === questionValue) {
                element.answer = answer;
              }
            });
          }
        });
      } else {
        data.forEach((item: any) => {
          if (item.question_title === questionTitle) {
            item.answer = answer;
          }
        });
      }
      this.setState({
        jsonWithAnswers: data,
        initialJsonWithAnswers: initialData,
        isPathSelected: true,
      });
    }
  };
  handleClose = () => {
    this.setState({
      isMenuOpen: false,
      isLeavePopUpOpen: false,
      isImportedJsonInvalid: false,
    });
  };

  handleDiscard = () => {
    let fileData = this.state.fileData?.[0]?.[0];
    let fileReader: any = new FileReader();

    fileReader.onload = () => {
      let content: any = JSON.parse(fileReader?.result);
      if (isArray(content) && content?.[0].input !== undefined) {
        this.setState(
          {
            fileContent: content?.[0].input,
          },
          () => {
            this.handlePathSelection(content?.[0].input);
          }
        );
      } else {
        this.setState(
          {
            isImportedJsonInvalid: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isImportedJsonInvalid: false,
              });
            }, 3000);
          }
        );
      }
    };
    fileReader.readAsText(fileData);
    this.setState({
      isLeavePopUpOpen: false,
    });
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  handleOnClickInputMenu = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    });
  };

  handleSearch = (valueToSearch: any) => {
    if (valueToSearch.length > 0) {
      this.setState({
        isSearch: true,
      });
    } else {
      this.setState({
        isSearch: false,
      });
    }
  };

  handleCross = (e: any) => {
    if (this.state.isSearch) {
      this.setState({
        valueToSearch: "",
      });
    }
    this.setState({
      isSearch: false,
    });
  };

  handleAccordionState = () => {
    const { accordionItemsState } = this.state;
    this.setState({
      isMenuOpen: false,
    });

    if (accordionItemsState === "collapsed") {
      this.setState({
        isExpandAll: true,
        accordionItemsState: "expanded",
      });
      // const accordionButtonElement: Element | any = document.querySelectorAll(
      //   ".accordion_input_button"
      // );
      // accordionButtonElement.forEach((element: any) => {
      //   element.setAttribute("aria-expanded", "true");
      // });
      // const accordionPanelElement: Element | any = document.querySelectorAll(
      //   ".accordion_input_panel"
      // );
      // accordionPanelElement.forEach((element: any) => {
      //   element.removeAttribute("hidden");
      // });
      // this.setState({
      //   accordionItemsState: "expanded",
      // });
    }
    if (accordionItemsState === "expanded") {
      this.setState({
        isExpandAll: false,
        accordionItemsState: "collapsed",
      });
      // const accordionButtonElement: Element | any = document.querySelectorAll(
      //   ".accordion_input_button"
      // );
      // accordionButtonElement.forEach((element: any) => {
      //   element.setAttribute("aria-expanded", "false");
      // });
      // const accordionPanelElement: Element | any = document.querySelectorAll(
      //   ".accordion_input_panel"
      // );
      // accordionPanelElement.forEach((element: any) => {
      //   element.setAttribute("hidden", "true");
      // });
      // this.setState({
      //   accordionItemsState: "collapsed",
      // });
    }
  };
  setUserResponse = (respData: any) => {
    let userDataObj: any = {};
    userDataObj.recoId = respData.recoId;
    userDataObj.recoValues = respData.recoValues;
    userDataObj.values = respData.values;
    this.addUpdateResponseData(userDataObj);
  };
  addUpdateResponseData = (newObject: any) => {
    this.state.storeUserResponse.push(newObject);
  };
  handleRun = (buttonLabel: string) => {
    this.props.handleRunLoad(true);
    if (buttonLabel === "Edit") {
      localStorage.removeItem("meta_result");
      this.setState({ buttonLabel: "Run" });
      if (this.props.callBack) {
        this.props.callBack(null);
      }
    } else {
      const { jsonWithAnswers, selectedPath } = this.state;
      let responseData: Object = {};
      if (selectedPath.id === "long-survey") {
        responseData = {
          recoId: "short_survey",
          recoValues: 0,
          values: selectedPath?.id,
        };
      } else {
        responseData = {
          recoId: "short_survey",
          recoValues: 1,
          values: selectedPath?.id,
        };
      }
      this.setUserResponse(responseData);

      jsonWithAnswers &&
        jsonWithAnswers.map((dataCell: any) => {
          if (dataCell.question_type === "multiple_choice_short_answer_none") {
            let responseData: Object = {};
            let recoValue: Array<String> = [];
            let values: Array<String> = [];
            if (dataCell.answer) {
              if (!_.isEmpty(dataCell?.answer)) {
                _.map(dataCell?.answer, (data: any) => {
                  if (data?.isChecked) {
                    recoValue.push(data?.id);
                    values.push(data?.value);
                  }
                });
                if (recoValue.length > 0) {
                  responseData = {
                    recoId: dataCell?.question_value,
                    recoValues: recoValue,
                    values: values,
                  };
                }
                this.setUserResponse(responseData);
              }
            }
          } else if (
            dataCell.question_type === "multiple-selection-with-none"
          ) {
            let responseData: Object = {};
            let recoValue: Array<String> = [];
            let values: Array<String> = [];
            if (dataCell.answer) {
              if (!_.isEmpty(dataCell?.answer)) {
                _.map(dataCell?.answer, (data: any) => {
                  if (data?.isChecked) {
                    recoValue.push(data?.id);
                    values.push(data?.value);
                  }
                });
                if (recoValue.length > 0) {
                  responseData = {
                    recoId: dataCell?.question_value,
                    recoValues: recoValue,
                    values: values,
                  };
                }
                this.setUserResponse(responseData);
              }
            }
          } else if (dataCell.question_type === "single_choice") {
            if (dataCell.answer) {
              let responseData: Object = {};
              if (dataCell.answer) {
                responseData = {
                  recoId: dataCell?.question_value,
                  recoValues: dataCell?.answer?.id,
                  values: dataCell?.answer?.value,
                };
                this.setUserResponse(responseData);
              }
            }
          } else if (dataCell.question_type === "dropdown") {
            let responseData: Object = {};
            dataCell.dropdown_combo.map((data: any) => {
              if (data.answer) {
                responseData = {
                  recoId: data?.question_value,
                  recoValues: data?.answer.id,
                  values: data?.answer.value,
                };
                this.setUserResponse(responseData);
              }
            });
          } else if (dataCell.question_type === "numeric") {
            if (dataCell.answer) {
              let responseData: Object = {};
              responseData = {
                recoId: dataCell?.question_value,
                recoValues: dataCell?.answer?.value,
                //values: dataCell?.answer?.value,
              };
              if (dataCell?.answer?.value > 0) {
                this.setUserResponse(responseData);
              }
            }
          } else if (dataCell.question_type === "ranking") {
            let responseData: Object = {};
            let recoValue: Array<String> = [];
            let values: Array<String> = [];
            if (dataCell.answer) {
              if (!_.isEmpty(dataCell?.answer)) {
                dataCell?.answer.map((data: any) => {
                  recoValue.push(data?.id);
                  values.push(data?.value);
                });

                responseData = {
                  recoId: dataCell?.question_value,
                  recoValues: recoValue,
                  values: values,
                };
                this.setUserResponse(responseData);
              }
            } else {
              responseData = {
                recoId: dataCell?.question_value,
                recoValues: [],
                values: [],
              };
              this.setUserResponse(responseData);
            }
          } else if (dataCell.question_type === "short_survey_ranking") {
            let responseData: Object = {};
            let recoValue: Array<String> = [];
            let values: Array<String> = [];
            if (dataCell.answer) {
              if (!_.isEmpty(dataCell?.answer)) {
                dataCell?.answer.map((data: any) => {
                  recoValue.push(data?.id);
                  values.push(data?.value);
                });
                if (recoValue.length > 0) {
                  responseData = {
                    recoId: dataCell?.question_value,
                    recoValues: recoValue,
                    values: values,
                  };
                }
                this.setUserResponse(responseData);
              }
            }
          } else {
            let responseData: Object = {};
            let recoValue: Array<String> = [];
            let values: Array<String> = [];
            if (dataCell.answer) {
              if (!_.isEmpty(dataCell?.answer)) {
                _.map(dataCell?.answer, (data: any) => {
                  if (data?.isChecked) {
                    recoValue.push(data?.id);
                    values.push(data?.value);
                  }
                });
                if (recoValue.length > 0) {
                  responseData = {
                    recoId: dataCell?.question_value,
                    recoValues: recoValue,
                    values: values,
                  };
                }
                this.setUserResponse(responseData);
              }
            }
          }
        });
      this.createRecoData(this.state.storeUserResponse);
    }
  };
  handlePathSelection = (dataObj: any) => {
    if (dataObj?.["short_survey"] === 0) {
      let data: any = _.cloneDeep(this.state.longSurveyQuestions);
      data.forEach((element: any) => {
        if (element.question_type === "ranking") {
          // element.answer = [
          //   { id: "everyday-health", value: "Everyday Health" },
          // ];
        }
      });
      this.setState(
        {
          jsonWithAnswers: data,
          initialJsonWithAnswers: data,
          isPathSelected: true,
          selectedPath: {
            id: "long-survey",
            value: "Holistic Path",
            isChecked: true,
          },
          surveyName: "Holistic Path",
          invalidAnswers: [],
        },
        () => {
          this.updateQuestionsList(dataObj, data);
        }
      );
    }
    if (dataObj?.["short_survey"] === 1) {
      let data: any = _.cloneDeep(this.state.shortSurveyQuestions);

      data.forEach((element: any) => {
        if (element.question_type === "short_survey_ranking") {
        }
      });
      this.setState(
        {
          jsonWithAnswers: data,
          initialJsonWithAnswers: data,
          isPathSelected: true,
          selectedPath: {
            id: "short-survey",
            value: "Focused Path",
            isChecked: true,
          },
          surveyName: "Focused Path",
          invalidAnswers: [],
        },
        () => {
          this.updateQuestionsList(dataObj, data);
        }
      );
    }
  };

  updateQuestionsList = (data: any, questionsArray: any) => {
    const { jsonWithAnswers, initialJsonWithAnswers } = this.state;

    let tempArr = [...questionsArray];

    let dependency: any = [];
    tempArr.filter((element: any, index: number) => {
      let temp: any = {};
      temp.obj = element;
      temp.question = element?.dependent;
      if (element?.dependent?.length > 0) {
        dependency.push(temp);
      }
      if (element?.dependent?.length > 1) {
        let selectedNeedState = _.find(
          data,
          (obj, index) => index === "NeedstateRank"
        );

        let needStateAns = _.map(
          handleNestedSort(selectedNeedState),
          (value, key) => value
        );

        let needStateData = element?.dependent;
        const filteredData = needStateData.filter((element: any) =>
          needStateAns.find((ans: any) => element.conditions[0] === ans)
        );
        const sortedData = needStateAns.map((i: any) =>
          filteredData.find((j: any) => j.conditions[0] === i)
        );
        const compactSortedData = _.compact(sortedData);
        let result = _.map(compactSortedData, _.property("questions")).flat();
        result.filter((obj: any, num: number) => {
          if (obj?.dependent?.length > 0) {
            let temp: any = {};
            temp.obj = obj;
            temp.question = obj?.dependent;
            dependency.push(temp);
          }
        });
      }
    });

    //addition of dependency questions
    dependency.filter((element: any) => {
      if (element?.question?.length > 1) {
        let dependent = element?.obj?.options_list;

        let selectedAnsState = _.find(
          data,
          (obj, index) => index === element?.obj?.question_value
        );

        let needStateDependencyArr: any = [];
        let needStateAns: any = [];
        _.map(handleNestedSort(selectedAnsState), (value, key) => {
          let ansStateOption = _.find(dependent, (obj) => obj.id === value);
          if (ansStateOption === undefined) {
            this.setState({
              invalidAnswers: [...this.state.invalidAnswers, key],
            });
          } else {
            let obj: any = {};
            obj.id = value;
            obj.value = ansStateOption?.value;
            needStateAns.push(obj);
          }
        });

        const needStateData = _.find(jsonWithAnswers, {
          question_value: "NeedstateRank",
        }).dependent;
        const filteredData = needStateData.filter((element: any) =>
          needStateAns.find((ans: any) => element.conditions[0] === ans.id)
        );
        const sortedData = needStateAns.map((i: any) =>
          filteredData.find((j: any) => j.conditions[0] === i.id)
        );
        const compactSortedData = _.compact(sortedData);
        let result = _.map(compactSortedData, _.property("questions")).flat();

        const uniqueQuestions = _.uniqBy([...result], "question_value");
        let finalData: any = [];
        finalData = [...initialJsonWithAnswers];
        const objIndexAge = finalData.findIndex(
          (obj: any) => obj.question_value === "NeedstateRank"
        );

        finalData.splice(objIndexAge + 1, 0, ...uniqueQuestions);

        tempArr = [...finalData];
        const objIndex = tempArr.findIndex(
          (obj: any) => obj.question_value === "NeedstateRank"
        );
        tempArr[objIndex].answer = needStateAns;
      } else {
        let questionObj = element?.question?.[0]?.questions;
        let index = _.findIndex(tempArr, element?.obj);
        questionObj.forEach((ele: any) => {
          let ans = _.find(data, (obj, index) => index === ele?.question_value);
          ans !== undefined &&
            _.find(tempArr, ele) === undefined &&
            tempArr.splice(index + 1, 0, ele);
        });
      }
    });

    this.setState(
      {
        jsonWithAnswers: tempArr,
      },
      () => {
        this.handlePrefillData(data, tempArr);
      }
    );
  };

  handlePrefillData = (data: any, questionsArr: any) => {
    let tempArr = questionsArr;
    let invalidIdArray: any = [];
    //prefill logic for dropdown question type
    let dropdownQuestions: any = [];
    tempArr.forEach((item: any) => {
      if (item.question_type === "dropdown") {
        item.dropdown_combo.forEach((element: any) => {
          let answerList: any = {};
          let selectedOption = _.find(
            element?.options_list,
            (obj) =>
              obj.id ===
              _.find(
                data,
                (obj, index) => index === element?.question_value
              )?.toString()
          );
          let selectedIndex = _.findIndex(
            element?.options_list,
            selectedOption
          );
          if (selectedOption !== undefined) {
            selectedOption.isChecked = true;
            answerList.id = selectedOption?.id;
            answerList.value = selectedOption?.value;
            element.answer = answerList;
            dropdownQuestions.push(element);
          } else {
            invalidIdArray.push(element?.question_value);
          }
        });
      }
    });

    //prefill logic for other questions type
    _.map(data, (value: any, key) => {
      let selectedObj = _.find(tempArr, (obj) => obj?.question_value === key);
      let selectedObjIndex = _.findIndex(tempArr, selectedObj);
      if (selectedObj?.question_type === "numeric") {
        let obj: any = {};
        obj.id = key;
        obj.value = value.toString();
        selectedObj.answer = obj;
        tempArr.splice(selectedObjIndex, 1, selectedObj);
      }
      if (selectedObj?.question_type === "single_choice") {
        if (
          _.find(
            selectedObj?.options_list,
            (obj) => obj?.id === value.toString()
          ) !== undefined
        ) {
          selectedObj.answer = _.find(
            selectedObj?.options_list,
            (obj) => obj?.id === value.toString()
          );
          tempArr[selectedObjIndex] = selectedObj;
        } else {
          invalidIdArray.push(selectedObj?.question_value);
        }
      }
      if (
        selectedObj?.question_type === "multiple_choice_short_answer" ||
        selectedObj?.question_type === "multiple-selection"
      ) {
        let optionsList = selectedObj?.options_list;
        let selectedAnswers =
          isArray(value) &&
          optionsList.filter((object: any) =>
            value.find((ans: any) => ans === object?.id)
          );

        let ans = [];
        if (selectedAnswers.length === 0) {
          invalidIdArray.push(selectedObj?.question_value);
        } else {
          for (let index = 0; index < optionsList.length; index++) {
            if (value?.toString()?.includes(optionsList[index]?.id)) {
              let obj: any = {};
              obj.id = optionsList[index]?.id;
              obj.value = optionsList[index]?.value;
              obj.isChecked = true;
              ans.push(obj);
            } else {
              ans.push(optionsList[index]);
            }

            selectedObj.answer = ans;
            tempArr.splice(selectedObjIndex, 1, selectedObj);
          }
        }
      }
      if (
        selectedObj?.question_type === "multiple_choice_short_answer_none" ||
        selectedObj?.question_type === "multiple-selection-with-none" ||
        selectedObj?.question_type === "search-select"
      ) {
        let ans = [];
        let optionsList = selectedObj?.options_list;
        let selectedAnswers = [];
        if (value?.length > 0) {
          selectedAnswers = optionsList.filter((object: any) =>
            value.find((ans: any) => ans === object?.id)
          );
          _.isEmpty(selectedAnswers) &&
            invalidIdArray.push(selectedObj?.question_value);
        }
        if (
          _.isEmpty(selectedAnswers) &&
          (selectedObj?.question_value === "FoodDislikes" ||
            selectedObj?.question_value === "Allergy")
        ) {
          // let ans = [];
          let data = _.cloneDeep(optionsList);
          data.forEach(function (item: {
            isChecked: boolean;
            isDisabled: boolean;
          }) {
            item.isChecked = false;
            item.isDisabled = true;
          });
          let obj: any = {};
          obj.id = "None";
          obj.value =
            selectedObj?.question_value === "FoodDislikes"
              ? "No Dislikes"
              : "No Allergies";
          obj.isChecked = true;
          obj.isDisabled = false;

          if (
            selectedObj?.question_value === "Allergy" &&
            this.state.surveyName === "Holistic Path"
          ) {
            data[0]?.id !== "None" && data.unshift(obj);
          }
          if (selectedObj?.question_value === "FoodDislikes") {
            data[0]?.id !== "None" && data.unshift(obj);
          }
          // ans = _.cloneDeep(data);
          selectedObj.answer = _.cloneDeep(data);
          tempArr.splice(selectedObjIndex, 1, selectedObj);
          console.log("valuesss", data, value, selectedAnswers);
        }
        if (value === 0 || selectedAnswers.length > 0) {
          if (
            selectedObj?.question_value === "Allergy" &&
            this.state.surveyName === "Holistic Path"
          ) {
            optionsList[0]?.id !== "None" &&
              optionsList.unshift({
                id: "None",
                isChecked: false,
                isDisabled: false,
                value: "No Allergies",
              });
          }
          if (selectedObj?.question_value === "FoodDislikes") {
            optionsList[0]?.id !== "None" &&
              optionsList.unshift({
                id: "None",
                isChecked: false,
                isDisabled: false,
                value: "No Dislikes",
              });
          }
          for (let index = 0; index < optionsList.length; index++) {
            let obj: any = {};
            if (value === 0) {
              obj.id = optionsList[index]?.id;
              obj.value = optionsList[index]?.value;
              obj.isChecked = optionsList[index]?.id === "None" ? true : false;
              obj.isDisabled = optionsList[index]?.id === "None" ? false : true;
            } else {
              if (
                value?.length > 0 &&
                value?.includes(optionsList[index]?.id)
              ) {
                obj.id = optionsList[index]?.id;
                obj.value = optionsList[index]?.value;
                obj.isChecked = true;
                obj.isDisabled = false;
              } else {
                obj.id = optionsList[index]?.id;
                obj.value = optionsList[index]?.value;
                obj.isChecked = false;
                if (
                  (selectedObj?.question_value === "FoodDislikes" ||
                    selectedObj?.question_value === "Allergy") &&
                  this.state.surveyName === "Holistic Path"
                ) {
                  obj.isDisabled =
                    value === 0 ? true : index === 0 ? true : false;
                } else {
                  obj.isDisabled =
                    value[0] === "none" || value[0] === "open"
                      ? true
                      : index + 1 === optionsList.length
                      ? true
                      : false;
                }
              }
            }
            ans.push(obj);
          }

          selectedObj.answer = ans;
          tempArr.splice(selectedObjIndex, 1, selectedObj);
        }
      }
    });
    this.setState({
      jsonWithAnswers: [...tempArr],
      isPathSelected: true,
      invalidAnswers: [..._.union(this.state.invalidAnswers, invalidIdArray)],
    });
  };

  importData = (data: any) => {
    const { isPathSelected } = this.state;
    this.setState({
      fileData: data,
    });
    if (isPathSelected) {
      this.setState({
        isLeavePopUpOpen: true,
      });
    } else {
      let fileData = data?.[0]?.[0];
      let fileReader: any = new FileReader();

      fileReader.onload = () => {
        let content: any = JSON.parse(fileReader?.result);
        if (isArray(content) && content?.[0].input !== undefined) {
          this.setState(
            {
              fileContent: content?.[0].input,
              isPathSelected: true,
            },
            () => {
              this.handlePathSelection(content?.[0].input);
            }
          );
        } else {
          this.setState(
            {
              isImportedJsonInvalid: true,
            },
            () => {
              setTimeout(() => {
                this.setState({
                  isImportedJsonInvalid: false,
                });
              }, 3000);
            }
          );
        }
      };
      fileReader.readAsText(fileData);
    }
    // this.setState({
    //   isMenuOpen: false
    // })
  };
  handleImport = (e: any) => {
    e.preventDefault();
    this.setState({
      isMenuOpen: false,
    });
    let input = document.createElement("input");
    let files: any;
    input.type = "file";
    input.accept = ".json";
    input.onchange = (_) => {
      // you can use this method to get file and perform respective operations
      files = Array(input?.files);
      this.importData(files);
    };
    input.click();
  };

  handleDragAndDrop = (e: any) => {
    e.preventDefault();
    let fileData = e.dataTransfer.files[0];
    let fileReader: any = new FileReader();
    this.setState({
      isFileDragged: false,
    });
    fileReader.onload = () => {
      let content: any = JSON.parse(fileReader?.result);
      if (isArray(content) && content[0].input !== undefined) {
        this.setState(
          {
            fileContent: content?.[0]?.input,
          },
          () => {
            this.handlePathSelection(content?.[0]?.input);
          }
        );
      } else {
        this.setState(
          {
            isImportedJsonInvalid: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                isImportedJsonInvalid: false,
              });
            }, 3000);
          }
        );
      }
    };
    fileReader.readAsText(fileData);
  };
  dropOverHandler = (e: any) => {
    // Prevent default behavior (Prevent file from being opened)
    e.preventDefault();

    this.setState({
      isFileDragged: true,
    });
  };

  handleOnAccordionChange = () => {
    this.setState({
      isExpandAll: undefined,
    });
  };

  render() {
    const { isRulesVisiable, isViewMode, isEditMode } = this.props;
    const {
      jsonWithAnswers,
      surveyName,
      isMenuOpen,
      accordionItemsState,
      valueToSearch,
      isPathSelected,
      initialJsonWithAnswers,
      isFileDragged,
      selectedPath,
      buttonLabel,
      fileContent,
      isSearch,
      isLeavePopUpOpen,
      isImportedJsonInvalid,
      isApiFailed,
      isExpandAll,
    } = this.state;

    const inputsDisabled = isViewMode && !isEditMode;
    let isPathDisplay: boolean = true;
    let path: any = "path";
    let filteredData: any = [];
    if (valueToSearch?.trim()?.length > 1) {
      const filteredResult = jsonWithAnswers?.filter(
        (item: any) =>
          item &&
          item?.question_value
            ?.toLowerCase()
            ?.includes(valueToSearch?.trim()?.toLowerCase())
      );
      let arrayOfElements = [...jsonWithAnswers];
      let dropdownFilteredData = arrayOfElements.map((element) => {
        if (element.question_type === "dropdown") {
          return {
            ...element,
            dropdown_combo: element?.dropdown_combo?.filter((subElement: any) =>
              subElement?.question_value
                ?.toLowerCase()
                ?.includes(valueToSearch?.trim()?.toLowerCase())
            ),
          };
        }
      });
      const compactDropdownFilteredData = _.compact(dropdownFilteredData);
      const dropDownResult = compactDropdownFilteredData.filter(
        (item: any) => item && item?.dropdown_combo?.length > 0
      );
      let allFilteredResult: any = [...filteredResult, ...dropDownResult];
      filteredData = [...allFilteredResult];

      if (path.indexOf(valueToSearch?.trim()?.toLowerCase()) !== -1) {
        isPathDisplay = true;
      } else {
        isPathDisplay = false;
      }
    }

    let dataToDisplay: any =
      valueToSearch?.trim()?.length > 1 ? filteredData : jsonWithAnswers;

    const selectedNeedStates = _.find(jsonWithAnswers, {
      question_value: "NeedstateRank",
    })?.answer;

    return (
      <div className={`input-area section pull-left`}>
        {!isRulesVisiable && (
          <div
            className="view-rules-btn"
            onClick={() => this.props.handleViewRules(true)}
          >
            <span>View Rules</span>
          </div>
        )}
        {/* <div className="title">Enter the Input values here</div> */}
        {/* Path Change Popup Start */}
        {isLeavePopUpOpen && (
          <AdminPopupComponent
            open={isLeavePopUpOpen}
            close={this.handleClose}
            onDelete={this.handleDiscard}
            buttonName={"Discard"}
            cancleButtonName={"Cancel"}
            heading={"Hold on"}
            title={"Are you sure you want to change the input?"}
          />
        )}
        {/* path change Popup End */}
        {/* Invalid Json Imported Popup Start */}
        {isImportedJsonInvalid ? (
          <MessageStrip
            messageText={"The imported JSON file is invalid"}
            error
          />
        ) : null}
        {isApiFailed ? (
          <MessageStrip
            messageText={"Something went wrong. Try again or start over"}
            error
          />
        ) : null}
        {/* {isImportedJsonInvalid && (
          <AdminPopupComponent
            open={isImportedJsonInvalid}
            close={this.handleClose}
            // onDelete={this.handleDiscard}
            buttonName={"Ok"}
            cancleButtonName={"Cancel"}
            heading={"Invalid Json"}
            // title={"Are you sure you want to change the input?"}
          />
        )} */}
        {/* Invalid Json Imported Popup End */}

        {/* Input inner area Start */}
        <div className={"inner-wrapper "}>
          <div className="title-header">
            <div className="title">Input</div>
            <div className="main-input">
              <div className="search-wrapper">
                <InputField
                  type={"text"}
                  placeHolder={"Search question name"}
                  className={"custom-input"}
                  handleInputChange={(evt: any) => {
                    this.handleSearch(evt.target.value.toLowerCase());
                    this.setState({
                      valueToSearch: evt.target.value,
                    });
                  }}
                  inputValue={valueToSearch}
                />
                <div
                  className={isSearch ? "icon cross-icon" : "icon search-icon"}
                  onClick={(e) => this.handleCross(e)}
                ></div>
              </div>
              <div
                className="section-options-wrapper"
                onClick={this.handleOnClickInputMenu}
              >
                <span
                  className="icon three-dot-icon"
                  // onClick={this.handleOnClickInputMenu}
                />
                <div
                  ref={(node) => {
                    this.node = node;
                  }}
                  className={isMenuOpen ? "options-view" : "hide"}
                >
                  <div
                    className="option"
                    onClick={(e) => {
                      this.handleImport(e);
                    }}
                  >
                    Import JSON
                  </div>
                  {!_.isEmpty(surveyName) && (
                    <div className="option" onClick={this.handleAccordionState}>
                      {accordionItemsState === "expanded" &&
                        "Collapse all Questions"}

                      {accordionItemsState === "collapsed" &&
                        "Expand all Questions"}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="custom-accordion">
            {/* Accordion Area Start */}

            {/* Search Information Area Starts */}
            {valueToSearch?.trim()?.length > 1 && (
              <div className="results-search-info">
                {filteredData.length > 0 || isPathDisplay
                  ? `Showing results for "${valueToSearch}"`
                  : `No results for "${valueToSearch}"`}
              </div>
            )}
            {/* Search Information Area Ends */}

            <Accordion
              preExpanded={["Path"]}
              allowZeroExpanded={true}
              onChange={this.handleOnAccordionChange}
            >
              {isPathDisplay && (
                <AccordionItem uuid="Path">
                  {/* <AccordionItemHeading> */}
                  <AccordionItemButton className="accordion_input_button">
                    <div
                      className={
                        isFileDragged
                          ? "item-btn-wrapper hide"
                          : "item-btn-wrapper"
                      }
                    >
                      <div className="question-title">Path</div>
                      <div
                        className={
                          _.isEmpty(surveyName) ? "answers" : "answers active"
                        }
                      >
                        {_.isEmpty(surveyName)
                          ? "Unanswered"
                          : surveyName && surveyName}
                      </div>
                    </div>
                  </AccordionItemButton>
                  {/* </AccordionItemHeading> */}
                  <AccordionItemPanel className="accordion_input_panel">
                    <div
                      className={
                        isFileDragged
                          ? "question-answer-area hide"
                          : "question-answer-area"
                      }
                    >
                      <div className="question">
                        Health isn’t one size fits all. So take the assessment
                        that works for you.
                      </div>

                      {/* <SingleChoiceComponent /> */}
                      {
                        <SingleChoiceComponent
                          questionType="single_choice"
                          questionValue="Path"
                          questionTitle="Health isn’t one size fits all. So take the assessment
                                 that works for you"
                          optionList={[
                            { id: "long-survey", value: "Holistic Path" },
                            { id: "short-survey", value: "Focused Path" },
                          ]}
                          optionsListWithAnswer={selectedPath}
                          dependent={[]}
                          isPath={isPathSelected}
                          disableAllAnswers={inputsDisabled}
                          handleInputChange={(
                            questionType: string,
                            questionValue: string,
                            questionTitle: string,
                            answer: any,
                            isNeedState: boolean,
                            isDependent: boolean,
                            dependentQuestions: any
                          ) =>
                            this.handleInputChange(
                              questionType,
                              questionValue,
                              questionTitle,
                              answer,
                              isNeedState,
                              isDependent,
                              dependentQuestions
                            )
                          }
                        />
                      }
                      {/* Single Choice Ends */}

                      {/* Answer Section Ends */}
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {isPathSelected &&
                dataToDisplay &&
                !_.isEmpty(dataToDisplay) &&
                dataToDisplay.map((item: any) =>
                  item?.question_type === "dropdown" ? (
                    item?.dropdown_combo?.map((element: any, index: number) => (
                      <AccordionItem
                        uuid={element?.question_value}
                        dangerouslySetExpanded={isExpandAll}
                      >
                        {/* <AccordionItemHeading> */}
                        <AccordionItemButton className="accordion_input_button">
                          <div className="item-btn-wrapper">
                            <div className="question-title">
                              {element?.question_value}
                            </div>
                            <div
                              className={
                                _.isEmpty(element?.answer?.value)
                                  ? "answers"
                                  : "answers active"
                              }
                            >
                              {_.isEmpty(element?.answer?.value)
                                ? "Unanswered"
                                : element?.answer?.value}
                            </div>
                          </div>
                        </AccordionItemButton>
                        {/* </AccordionItemHeading> */}
                        <AccordionItemPanel className="accordion_input_panel">
                          <div className="question-answer-area">
                            <div className="question">
                              {item.question_title}
                            </div>
                            {/* Answer Section Start */}
                            {/* Single Choice Start */}

                            <SingleChoiceComponent
                              questionType={element?.question_type}
                              questionValue={element?.question_value}
                              questionTitle={item?.question_title}
                              optionList={element?.options_list}
                              optionsListWithAnswer={element?.answer}
                              dependent={element?.dependent}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean,
                                isDependent: boolean,
                                dependentQuestions: any
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState,
                                  isDependent,
                                  dependentQuestions
                                )
                              }
                            />
                            {/* Single Choice Ends */}

                            {/* Answer Section Ends */}
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>
                    ))
                  ) : (
                    <AccordionItem
                      uuid={item?.question_value}
                      dangerouslySetExpanded={isExpandAll}
                    >
                      {/* <AccordionItemHeading> */}
                      <AccordionItemButton className="accordion_input_button">
                        <div className="item-btn-wrapper">
                          <div className="question-title">
                            {item?.question_value}
                          </div>
                          {(item?.question_type === "single_choice" ||
                            item?.question_type === "numeric") && (
                            <div
                              className={
                                _.isEmpty(item?.answer?.value)
                                  ? "answers"
                                  : "answers active"
                              }
                            >
                              {_.isEmpty(item?.answer?.value)
                                ? "Unanswered"
                                : item?.answer?.value}
                            </div>
                          )}
                          {(item?.question_type === "ranking" ||
                            item?.question_type === "short_survey_ranking") && (
                            <>
                              <div
                                className={
                                  _.isEmpty(item?.answer)
                                    ? "answers"
                                    : "answers active"
                                }
                              >
                                {_.isEmpty(item?.answer)
                                  ? "Unanswered"
                                  : item?.answer
                                      ?.map((item: any) => item["value"])
                                      ?.join(",")}
                              </div>
                            </>
                          )}
                          {(item?.question_type ===
                            "multiple_choice_short_answer" ||
                            item?.question_type === "multiple-selection" ||
                            item?.question_type ===
                              "multiple_choice_short_answer_none") && (
                            <div
                              className={
                                _.pick(_.countBy(item?.answer, "isChecked"), [
                                  "true",
                                ]).true > 0
                                  ? "answers active"
                                  : "answers "
                              }
                            >
                              {(item?.question_type ===
                                "multiple_choice_short_answer" ||
                                item?.question_type === "multiple-selection" ||
                                item?.question_type ===
                                  "multiple_choice_short_answer_none") &&
                              _.pick(_.countBy(item?.answer, "isChecked"), [
                                "true",
                              ]).true > 0
                                ? item?.answer
                                    ?.filter(
                                      (item: any) => item?.isChecked === true
                                    )
                                    .map((item: any) => item["id"])
                                    .join(",")
                                : "Unanswered"}
                            </div>
                          )}

                          {(item?.question_type === "search-select" ||
                            item?.question_type ===
                              "multiple-selection-with-none") && (
                            <div
                              className={
                                _.pick(_.countBy(item?.answer, "isChecked"), [
                                  "true",
                                ]).true > 0
                                  ? "answers active"
                                  : "answers "
                              }
                            >
                              {(item?.question_type === "search-select" ||
                                item?.question_type ===
                                  "multiple-selection-with-none") &&
                              _.pick(_.countBy(item?.answer, "isChecked"), [
                                "true",
                              ]).true > 0
                                ? item?.answer
                                    ?.filter(
                                      (item: any) => item?.isChecked === true
                                    )
                                    .map((item: any) => item["value"])
                                    .join(",")
                                : "Unanswered"}
                            </div>
                          )}

                          {/* {(item?.question_type ===
                            "multiple-selection-with-none" ||
                            item?.question_type === "search-select") && (
                            <div
                              className={
                                _.pick(_.countBy(item?.answer, "isChecked"), [
                                  "true",
                                ]).true > 0
                                  ? "answers active"
                                  : "answers "
                              }
                            >
                              {(item?.question_type ===
                                "multiple-selection-with-none" ||
                                item?.question_type === "search-select") &&
                              _.pick(_.countBy(item?.answer, "isChecked"), [
                                "true",
                              ]).true > 0
                                ? item?.answer
                                    ?.filter(
                                      (item: any) => item?.isChecked === true
                                    )
                                    .map((item: any) => item["value"])
                                    .join(",")
                                : "Unanswered"}
                            </div>
                          )} */}
                        </div>
                      </AccordionItemButton>
                      {/* </AccordionItemHeading> */}
                      <AccordionItemPanel className="accordion_input_panel">
                        <div className="question-answer-area">
                          <div className="question">{item?.question_title}</div>
                          {/* Answer Section Start */}

                          {/* Single Choice Start */}
                          {item?.question_type === "single_choice" && (
                            <SingleChoiceComponent
                              questionType={item?.question_type}
                              questionValue={item?.question_value}
                              questionTitle={item?.question_title}
                              optionList={item?.options_list}
                              optionsListWithAnswer={item?.answer}
                              dependent={item?.dependent}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean,
                                isDependent: boolean,
                                dependentQuestions: any
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState,
                                  isDependent,
                                  dependentQuestions
                                )
                              }
                            />
                          )}
                          {/* Single Choice Ends */}

                          {/* Multiple Choice Start */}
                          {(item?.question_type === "multiple-selection" ||
                            item?.question_type ===
                              "multiple-selection-with-none" ||
                            item?.question_type ===
                              "multiple_choice_short_answer" ||
                            item?.question_type ===
                              "multiple_choice_short_answer_none") && (
                            <MultipleChoiceComponent
                              questionType={item?.question_type}
                              questionValue={item?.question_value}
                              questionTitle={item?.question_title}
                              optionList={item?.options_list}
                              optionsListWithAnswer={item?.answer}
                              dependent={item?.dependent}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean,
                                isDependent: boolean,
                                dependentQuestions: any
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState,
                                  isDependent,
                                  dependentQuestions
                                )
                              }
                            />
                          )}
                          {/* Multiple Choice Ends */}

                          {/* Numeric Component Start */}
                          {item?.question_type === "numeric" && (
                            <NumericValueComponent
                              questionType={item?.question_type}
                              questionValue={item?.question_value}
                              questionTitle={item?.question_title}
                              inputPlaceHolder={item?.question_title}
                              answer={item?.answer}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState
                                )
                              }
                            />
                          )}
                          {/* Numeric Component Ends */}

                          {/* Search and select Component Starts */}
                          {item?.question_type === "search-select" && (
                            <SearchSelectComponent
                              questionType={item?.question_type}
                              questionValue={item?.question_value}
                              questionTitle={item?.question_title}
                              optionList={item?.options_list}
                              optionsListWithAnswer={item?.answer}
                              dependent={item?.dependent}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean,
                                isDependent: boolean,
                                dependentQuestions: any
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState,
                                  isDependent,
                                  dependentQuestions
                                )
                              }
                            />
                          )}

                          {/*Search & Select Component Ends */}

                          {/* NeedState Long survey Starts */}
                          {item?.question_type === "ranking" && (
                            <LongSuveryRankingComponent
                              questionType={item?.question_type}
                              questionValue={item?.question_value}
                              questionTitle={item?.question_title}
                              optionList={item?.options_list}
                              optionsListWithAnswer={item?.answer}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState
                                )
                              }
                            />
                          )}
                          {/* NeedState Long survey ends */}

                          {/* NeedState Short survey Starts */}
                          {item?.question_type === "short_survey_ranking" && (
                            <ShortSuveryRankingComponent
                              questionType={item?.question_type}
                              questionValue={item?.question_value}
                              questionTitle={item?.question_title}
                              optionList={item?.options_list}
                              optionsListWithAnswer={item?.answer}
                              disableAllAnswers={inputsDisabled}
                              handleInputChange={(
                                questionType: string,
                                questionValue: string,
                                questionTitle: string,
                                answer: any,
                                isNeedState: boolean
                              ) =>
                                this.handleInputChange(
                                  questionType,
                                  questionValue,
                                  questionTitle,
                                  answer,
                                  isNeedState
                                )
                              }
                            />
                          )}
                          {/* NeedState Short survey ends */}
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  )
                )}
            </Accordion>

            {/* Accordion Area Ends */}

            {/* Import Json Section Start */}
            <div
              className={
                isFileDragged
                  ? "import-json-container drop-json-container"
                  : isPathSelected
                  ? "import-json-container hide"
                  : "import-json-container"
              }
              onDragStart={(e) => {
                e.dataTransfer.setData(".json", "This text may be dragged");
              }}
              onDrop={(e) => this.handleDragAndDrop(e)}
              onDragOver={(e) => this.dropOverHandler(e)}
              onDragLeave={(e) => {
                this.setState({
                  isFileDragged: false,
                });
              }}
            >
              <div className="import-btn-wrapper">
                <div className={isFileDragged ? "label hide" : "label"}>or</div>
                <div
                  className={isFileDragged ? "import-btn hide" : "import-btn"}
                >
                  <Button
                    name={"Import JSON"}
                    className="app-btn border-btn"
                    onButtonClick={(e) => {
                      this.handleImport(e);
                    }}
                  />
                </div>
                <div className="label">
                  {isFileDragged ? "drop" : "or drag and drop here"}
                </div>
              </div>
            </div>
            {/* Import Json Section Ends */}
          </div>
          {(!isViewMode || isEditMode) && (
            <div
              className={
                selectedNeedStates?.length > 0
                  ? "bottom-btn-area"
                  : "bottom-btn-area disabled"
              }
            >
              <Button
                onButtonClick={() => {
                  this.handleRun(buttonLabel);
                }}
                name={buttonLabel}
                //name={!_.isEmpty(data) ? "Edit" : "Run"}
                className={
                  buttonLabel === "Edit" ? "app-btn border-btn" : "app-btn"
                }
              />
            </div>
          )}
        </div>
        {/* Input inner area Ends */}
      </div>
    );
  }
}

export default InputSection;
